/** Nothing on the desk renders until someone is signed in. */
import { type ReactNode } from 'react';
import { useSession } from '../lib/auth';
import { LoginScreen } from './login';

export function AuthGate({ children }: { children: ReactNode }) {
  const { session, loading } = useSession();
  if (loading) return <div className="flex h-full items-center justify-center text-body text-ink-3">Signing in</div>;
  if (!session) return <LoginScreen />;
  return children;
}
